/**
 * Date/Datetime Editor
 * Handles configuration for date and datetime controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for date/datetime controls
 */
function renderDateEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;
  const inputType = control.type === 'datetime' ? 'datetime-local' : 'date';

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Min Date
          <input
            type={inputType}
            value={(control.config?.min as string) || ''}
            onChange={(e) => onConfigChange('min', e.target.value || undefined)}
            className="af-properties-tab__input"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Max Date
          <input
            type={inputType}
            value={(control.config?.max as string) || ''}
            onChange={(e) => onConfigChange('max', e.target.value || undefined)}
            className="af-properties-tab__input"
          />
        </label>
      </div>
    </div>
  );
}

/**
 * DateEditor - Handles date control configuration
 */
export const DateEditor: PropertyEditor = {
  type: 'date',
  label: 'Date',
  description: 'Configure min/max dates for date control',
  render: renderDateEditor,
};

/**
 * DatetimeEditor - Uses same implementation as date
 */
export const DatetimeEditor: PropertyEditor = {
  type: 'datetime',
  label: 'Datetime',
  description: 'Configure min/max datetimes for datetime control',
  render: renderDateEditor,
};
